var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.57 2.425c-.542-.543-1.654-.82-3.443-.224l-8.49 2.83c-1.379.462-2.355.977-2.971 1.487-.62.511-.799.947-.799 1.266 0 .318.18.753.798 1.263.616.508 1.592 1.022 2.971 1.481l2.52.84c.225.075.4.25.475.475l.84 2.52c.46 1.379.974 2.355 1.483 2.971.51.619.946.798 1.266.798.32 0 .755-.18 1.266-.798.508-.616 1.023-1.592 1.482-2.971l2.83-8.489c.591-1.79.315-2.906-.228-3.45Zm1.062-1.06c1.13 1.131 1.258 2.96.59 4.98v.002l-2.83 8.49c-.492 1.475-1.08 2.64-1.75 3.452-.668.81-1.487 1.343-2.422 1.343-.936 0-1.755-.534-2.423-1.343-.67-.811-1.258-1.977-1.749-3.452l-.721-2.164-2.164-.722c-1.475-.49-2.641-1.078-3.452-1.747C.9 9.537.367 8.72.367 7.784c0-.935.535-1.754 1.343-2.422.811-.67 1.976-1.26 3.452-1.753l8.49-2.83c2.021-.674 3.849-.546 4.98.586Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.219 7.529a.75.75 0 0 1 .001 1.06l-3.58 3.59a.75.75 0 0 1-1.062-1.059l3.58-3.59a.75.75 0 0 1 1.061-.002Z",
    fill: "#fff"
  })));
};
export default SvgSend;